"use client"
import { keepSelection } from "@/actions/selection/keep-selection"
import IconShoppingBag from "@/app/(site)/_components/Atoms/Icons/IconShoppingBag"
import { Err, Ok } from "@/types/generic/Result"
import { useQuery } from "@tanstack/react-query"
import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"
import { match } from "ts-pattern"
import Text from "../../Atoms/Text"
import DynamicLink from "../../Molecules/Link"

type CartButtonProps = {}

const CartButton: React.FC<CartButtonProps> = () => {
    const [cartItemLength, setCartItemLength] = useState<number>(0)

    const { data } = useQuery({
        queryKey: ["selection"],
        queryFn: () => keepSelection(),
        refetchOnWindowFocus: false
    })

    useEffect(() => {
        if (data) {
            match(data)
                .with(Ok, data => {
                    const length =
                        data.data.checkoutApiSelection?.selection?.items.reduce(
                            (a, b) => a + b.quantity,
                            0
                        ) || 0
                    setCartItemLength(length)
                })
                .with(Err, err => {
                    toast.error("Failed to retrieve cart items")
                })
                .exhaustive()
        }
    }, [data])

    return (
        <DynamicLink
            href={"/cart"}
            className="flex w-60 items-center justify-end gap-3 px-24 py-18"
        >
            <Text size="small" weight="regular">
                {cartItemLength || "0"}
            </Text>
            <IconShoppingBag className="h-[16px] w-[16px] flex-none" />
        </DynamicLink>
    )
}

export default CartButton
